<template>
    <div>
        <div id="mapContainer" style="width: 100%; height: 470px;"></div>
    </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
// import PaginationCom from '../../components/map/PaginationCom.vue';

import { streetLightMapGroupListAPI, streetLightMapDetectionListAPI } from "@/api";


export default {
    components: {
        // PaginationCom
    },
    data() {
        return {
            currentPage: 1,
            totalPages: 9, // 假设总页数是 100
            pageSize: 2, // 每页显示 5 个页码
            showStartDots: false,
            showMiddleDots: true,
            showEndDots: false,

            project_id: '',   // 项目id
            grouping_id: '', // 分组id
            grouping_Index: 0, // 分组索引

            lang: 'zh',
            hideOnSinglePage: false,
            total: 90,
            pagination: {
                pageSize: 10,
                p: 1
            },
            map: null,
            listData: [],
            batteryData: null,

            minVoltage: 0, // 最小电压
            maxVoltage: 0, // 最大电压
            differentialPressure: 0, // 压差
            Battery: 0, // 剩余电量
            batEcele_month: 0,
            totalEcele_month: 0,
            photovoltaic: 0,

            saveElectricity: 0,
            costSavingsType: false, // 计算电费弹窗
            saveData: {
                peakstartTimeSlot: ['', ''],   // 高峰时间段
                peakendTime: '',   // 高峰时间
                peakPrice: '',     // 高峰电价

                lowstartTimeSlot: ['', ''],   // 低谷时间段
                lowendTime: '',   // 低谷时间
                lowPrice: '',     // 低谷电价

                pinggustartTimeSlot: ['', ''],   // 平谷时间段
                pingguendTime: '',   // 平谷时间
                pingguPrice: '',     // 平谷电价

                lightingFixtures: '', // 
                // lightPower: '', // 储能路灯功率
                power: '',     // 标称功率
                energySaving: '',     // 传统灯具节能
                energyConservation: '', // 削峰填谷储能灯具节能
                energySavingMonthly: '',   // 传统灯具月节能
                energyConservationMonthly: '',  // 削峰填谷储能灯具月节能
            },

            jiesheng: false,
        }
    },

    mounted() {
        this.drawMap()
        console.log('wwwwww');
    },
    
    methods: {
        // 分组列表
        async grouList() {
            let obj = { project_id: this.project_id }
            if(this.grouping_id) obj = { grouping_id: this.grouping_id }

            const res = await streetLightMapGroupListAPI(obj);
            console.log(res);
            res.data.forEach((it) => {
                it['chilType'] = false
            })
            this.listData = res.data

            this.batEcele_month = res.batEcele_month
            this.totalEcele_month = res.totalEcele_month
            this.photovoltaic = res.photovoltaic
            
            // this.detectionList(this.listData[0].id)
            this.detectionList()
        },
        // 设备列表
        async detectionList() {
            let obj = { project_id: this.project_id }
            if(this.grouping_id) obj = { grouping_id: this.grouping_id }

            const res = await streetLightMapDetectionListAPI(obj);
        
            // console.log(res);
            this.listData.forEach((item) => {
                item.child = this.findParent(res, item.id)
                item.chilType = true
            })

            this.drawMap(res)

            console.log(this.listData);


            // this.listData[this.grouping_Index].child = res
            // this.listData[this.grouping_Index].chilType = true

            // console.log(this.listData);
            // this.drawMap()
            // console.log(this.listData[this.grouping_Index].child[0]);
        },

        // 数组找父级
        findParent(arr, child) {
            let fAr = []
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].grouping_id == child) {
                    fAr.push(arr[i])
                }
            }
            return fAr;
        },


        // 绘画地图
        drawMap(data) {
            let that = this
            console.log('wwwwwwwwwwwwwww');
            console.log(data);
            AMapLoader.load({
                key: '264f06dae15eb39d775cfa92c22cda76', // 替换为你的高德地图API Key
                version: '2.0',
                plugins: ['AMap.Geolocation'],
            }).then((AMap) => {
                console.log(AMap);
                this.map = new AMap.Map("mapContainer", {
                    mapStyle: "amap://styles/darkblue", //设置地图的显示样式
                    // 设置地图容器id
                    viewMode: "2D", // 是否为3D地图模式
                    zoom: 17, // 初始化地图级别
                    center: [120.26,30.18]
                });
                let item = {
                    name: 111,
                    id: 2233
                }
                     var markerContent = `<div name='1'>
                    <div style="padding: 3px;border-radius: 8px;background-color: #fff;min-width: 5rem;">
                        <p style="font-size: 18px;color: #000;">test</p>
                        <p style="font-size: 14px;color: #000;">ID: 123111</p>
                    </div>
                    <img src="https://ssmeqn.5hzs.com/hzxk/img/ludengIcon02.png" style="width: 50px;height: 50px;margin-top: 5px;" alt="">
                </div>`
                    var marker = new AMap.Marker({
                        position: ([120.26, 30.18]),
                        // 将 html 传给 content
                        content: markerContent,
                        // 以 icon 的 [center bottom] 为原点
                        offset: new AMap.Pixel(-13, -30),
                        extData: { item }, // 写入你的item对象,必须要加{}
                    });
                    marker.on('click', (e) => {
                        let markerItem = e.target.getExtData().item; // 获取item , 这个getExtData()是AMap.Marker的扩展方法
                        console.log(markerItem.name);
                        // console.log(e);
                        that.seek(markerItem.name)
                    });

                    this.map.add([marker]);
                // // 添加点位
                // for (var i = 0; i < data.length; i++) {
                //     let item = data[i]
                //     // console.log(item, 'glongglongglong');
                //     let jing = item.glong
                //     let wei = item.glat

                //     if (i == 0) {
                //         // 创建地图实例      
                //         this.map = new AMap.Map("mapContainer", {
                //             mapStyle: "amap://styles/darkblue", //设置地图的显示样式
                //             // 设置地图容器id
                //             viewMode: "2D", // 是否为3D地图模式
                //             zoom: 17, // 初始化地图级别
                //             center: [data[0].glong, data[0].glat], // 初始化地图中心点位置
                //         });
                //     }

                //     var markerContent = `<div name='${i}'>
                //     <div style="width: 11rem;height: 2.3rem;padding: 3px;border-radius: 8px;background-color: #fff;">
                //         <p style="font-size: 12px;">${item.name}</p>
                //         <p style="font-size: 9px;">ID: ${item.deviceName}</p>
                //     </div>
                //     <img src="https://ssmeqn.5hzs.com/hzxk/img/ludengIcon.png" style="width: 40px;height: 50px;margin-top: 5px;" alt="">
                // </div>`
                //     var marker = new AMap.Marker({
                //         position: ([jing, wei]),
                //         // 将 html 传给 content
                //         content: markerContent,
                //         // 以 icon 的 [center bottom] 为原点
                //         offset: new AMap.Pixel(-13, -30),
                //         extData: { item }, // 写入你的item对象,必须要加{}
                //     });
                //     marker.on('click', (e) => {
                //         let markerItem = e.target.getExtData().item; // 获取item , 这个getExtData()是AMap.Marker的扩展方法
                //         console.log(markerItem.name);
                //         // console.log(e);
                //         that.seek(markerItem.name)
                //     });

                //     this.map.add([marker]);

                // }



            });
        },







        // 剩余电量
        BatteryFun() {
            if (!this.batteryData[`bat_${1}_soc`]) return 0
            let arr = []
            for (var i = 1; i <= 8; i++) {
                if (this.batteryData[`bat_${i}_soc`]) {
                    arr.push(this.batteryData[`bat_${i}_soc`] * 1)
                }
            }
            arr.sort((a, b) => a - b); // 升序
            // 移除最大值和最小值
            arr.shift(); // 移除最小值
            arr.pop();   // 移除最大值
            // 计算剩余元素的平均值
            // console.log('剩余电量', arr)
            const sum = arr.reduce((total, num) => total + num, 0);
            // console.log('剩余电量', sum)
            this.Battery = (sum / arr.length).toFixed(0)
            // console.log(this.Battery)
        },
        // 查找最大值和最小值
        seekMaxMin() {
            if (!this.batteryData[`bat_${1}_vol`]) {
                this.minVoltage = 0
                this.maxVoltage = 0
                this.differentialPressure = 0
                return
            }

            let arr = []
            for (var i = 1; i <= 8; i++) {
                if (this.batteryData[`bat_${i}_vol`]) {
                    this.batteryData[`bat_${i}_vol`] = (this.batteryData[`bat_${i}_vol`] / 1000).toFixed(3)
                    arr.push(this.batteryData[`bat_${i}_vol`])
                }
            }
            arr.sort((a, b) => a - b); // 升序
            // console.log(arr)
            this.minVoltage = arr[0]
            this.maxVoltage = arr[arr.length - 1]
            this.differentialPressure = (this.maxVoltage - this.minVoltage).toFixed(3)
            // console.log(this.minVoltage, this.maxVoltage)
        },




        // 返回
        back() {
            this.$router.back();
        },
        changePage(pager) { // 分页器回调
            this.pagination = pager
            console.log(pager);

            // this.$emit('change', pager)
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages || page === this.currentPage) return;
            this.currentPage = page;
            console.log(this.currentPage);

            // this.deviceList()
        },
        next(type) {
            if (type == 'up') {
                if (this.currentPage > 1) {
                    this.currentPage--
                } else {
                    return
                }
            } else {
                if (this.currentPage < this.totalPages) {
                    this.currentPage++
                } else {
                    return
                }
            }

            console.log(this.currentPage);
            // this.deviceList()
        },


        seek(item) {
            console.log(item);

            this.listData[this.grouping_Index].child.forEach(element => {
                if (element.name == item) {
                    console.log(element);
                    this.setCenter(element)
                }
            });
        },

        setCenter(coordinate) {
             // 节省电费
             this.jiesheng = true

            console.log(coordinate);
            if(this.batteryData && coordinate.id == this.batteryData.id) {
                return
            }

            let jing = coordinate.glong
            let wei = coordinate.glat

            this.batteryData = coordinate

            this.BatteryFun()
            this.seekMaxMin()

            // this.map.setCenter([jing, wei]); //简写 设置地图中心点
            this.map.setCenter([jing, wei], false, 500)
            this.map.setZoom(20, false, 800)
        },



        visiblePages() {
            const start = Math.max(1, this.currentPage - Math.floor(this.pageSize / 2));
            const end = Math.min(this.totalPages, start + this.pageSize - 1);

            this.showStartDots = start > 1;
            this.showMiddleDots = end < this.totalPages && (start > 2 || end < this.totalPages - 1);
            this.showEndDots = end < this.totalPages - 1;

            return Array.from({ length: end - start + 1 }, (_, i) => i + start);
        },

        // 二氧化碳
        reduction() {
            if(!this.photovoltaic) return 0
            let num = this.photovoltaic.slice(0, -2);
            // console.log(num * 0.404);
            return Math.ceil(num * 0.404)
        },
        // 等效植树
        planting() {
            if(!this.photovoltaic) return 0
            let num = this.photovoltaic.slice(0, -2) * 0.404 / 5023
            // console.log(num);
            return Math.ceil(num)
        },

        btnOk() {
            if(this.saveData.peakstartTimeSlot.length != 2) {
                return
            }
            if(this.saveData.lowstartTimeSlot.length != 2) {
                return
            }
            if(this.saveData.pinggustartTimeSlot.length != 2) {
                return
            }
            
            if(!this.saveData.peakPrice) {
                return
            }
            if(!this.saveData.lowPrice) {
                return
            }
            if(!this.saveData.pingguPrice) {
                return
            }
            if(!this.saveData.lightingFixtures) {
                return
            }
            // if(!this.saveData.lightPower) {
            //     return
            // }
            
            let lightPower = this.batteryData.dischargePower / 1000
            let lightingFixtures = this.saveData.lightingFixtures / 1000

            // // 高峰时间
            this.saveData.peakendTime = this.getHoursBetweenTwoTimestamps(new Date(this.saveData.peakstartTimeSlot[0]).getTime(), new Date(this.saveData.peakstartTimeSlot[1]).getTime()).toFixed(2)
            // 低峰时间
            this.saveData.lowendTime = this.getHoursBetweenTwoTimestamps(new Date(this.saveData.lowstartTimeSlot[0]).getTime(), new Date(this.saveData.lowstartTimeSlot[1]).getTime())
            // 平谷时间
            this.saveData.pingguendTime = this.getHoursBetweenTwoTimestamps(new Date(this.saveData.pinggustartTimeSlot[0]).getTime(), new Date(this.saveData.pinggustartTimeSlot[1]).getTime())


            // 储能灯具节能
            let num1 = (lightPower * this.saveData.lowendTime * this.saveData.lowPrice)


            // 传统灯具节能
            let num2 = (lightingFixtures * this.saveData.peakendTime * this.saveData.peakPrice) + (lightingFixtures * this.saveData.lowendTime * this.saveData.lowPrice) + (lightingFixtures * this.saveData.pingguendTime * this.saveData.pingguPrice)
            
            // console.log(num2, num1);
            this.saveElectricity = (num2 - num1).toFixed(2)
            // console.log(this.saveData);
            localStorage.setItem('time', JSON.stringify(this.saveData))
            this.cancellation()
        },
        // 取消
        cancellation() {
            this.costSavingsType = false // 计算电费弹窗
            // this.saveData = {
            //     peakstartTimeSlot: ['', ''],   // 高峰时间段
            //     peakendTime: '',   // 高峰时间
            //     peakPrice: '',     // 高峰电价

            //     lowstartTimeSlot: ['', ''],   // 低谷时间段
            //     lowendTime: '',   // 低谷时间
            //     lowPrice: '',     // 低谷电价

            //     pinggustartTimeSlot: ['', ''],   // 平谷时间段
            //     pingguendTime: '',   // 平谷时间
            //     pingguPrice: '',     // 平谷电价

            //     lightPower: '', // 储能路灯功率
            //     power: '',     // 标称功率
            //     energySaving: '',     // 传统灯具节能
            //     energyConservation: '', // 削峰填谷储能灯具节能
            //     energySavingMonthly: '',   // 传统灯具月节能
            //     energyConservationMonthly: '',  // 削峰填谷储能灯具月节能
            // }
        },


        // 将时间戳转换为毫秒
        getHoursBetweenTwoTimestamps(timestamp1, timestamp2) {
            
            var diff = Math.abs(timestamp1 - timestamp2); // 计算差值，确保是正数

            if(timestamp1 > timestamp2) {
                diff = 86399000 - diff
            }

            // 将毫秒转换为小时
            return Math.ceil(diff / (1000 * 60 * 60))
        }

    }
};
</script>
<style>

</style>